<template>
  <div class="media-tab">
    <a-tabs
      @change="(el) => changeTab(el)"
      :activeKey="tabKey"
    >
      <a-tab-pane
        key="0"
        tab="Dodaj Arkusz mediowy"
      >
        <div>
          <div>
            <addMediaListTable
              v-if="tab[0]"
              :settings="settings"
              :user_setup="user_setup"
              :USER_ACTIVE="USER_ACTIVE"
              :domain="domain"
            />
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane
        key="1"
        tab="Lista Arkuszy mediowych"
      >
        <div>
          <report-media-list
            v-if="tab[1]"
            :settings="settings"
            :USER_ACTIVE="USER_ACTIVE"
            :user_setup="user_setup"
            :domain="domain"
          ></report-media-list>
        </div>
      </a-tab-pane>
      <a-tab-pane
        key="2"
        tab="Zestawienie prognozy mediowej"
      >
        <div>
          <approvalMediaForecasts
            v-if="tab[2]"
            :USER_ACTIVE="USER_ACTIVE"
            :dataFacture="dataFacture"
            :checkFacture="checkFacture"
            :settings="settings"
            :user_setup="user_setup"
            :domain="domain"
            @openSalesTable="openSalesTable"
            @openInvoice="openInvoice"
          />
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import addMediaListTable from "./media/addMediaListTable.vue";
import approvalMediaForecasts from "./media/approvalMediaForecasts";
import reportMediaList from "./media/reportMediaList";
export default {
  name: "mediaTab",
  props: [
    "settings",
    "USER_ACTIVE",
    "user_setup",
    "mediaForecasts",
    "checkFacture",
    "dataFacture",
  ],
  data: () => ({
    tab: [true, false, false],
    statusEdit: false,
    domain: "",
    tabKey: "0",
  }),
  components: {
    addMediaListTable,
    approvalMediaForecasts,
    reportMediaList,
  },
  methods: {
    changeTab: function (item) {
      for (let i in this.tab) {
        this.tab[i] = false;
      }
      this.tab[item] = true;
      this.tab = [...this.tab];
      this.tabKey = item;
    },
    openFacture: function (mediaList) {
      this.$emit("openFacture", mediaList);
    },
    openInvoice: function (data) {
      this.$emit("openInvoice", { invoice: data.invoice, sort: data.sort });
    },

    changeStatusEdit: function () {
      let userEditActive = [...this.user_setup.mediaResponsible].concat([
        ...this.user_setup.mediaAssigned,
      ]);
      this.statusEdit = Boolean(
        userEditActive.find((el) => el == this.USER_ACTIVE.ID)
      );
    },
    openSalesTable: function (data) {
      this.$emit("openSalesTable", data);
    },
  },
  mounted() {
    this.domain = BX24.getDomain();
    this.changeStatusEdit();
    this.tabKey = "0";
    if (this.checkFacture) {
      this.tab = [false, false, true];
      this.tabKey = "2";
    }
  },
};
</script>

<style>
.mainpage {
  min-height: 800px;
}
.media-tab {
  min-height: 800px;
}
</style>
